import { Component, OnInit, Input } from "@angular/core";
import { checkPostIsNew } from "@frontend/unhideschool/app/helpers/utility-functions";

@Component({
  selector: "unh-mosaico-item-super-trunfo",
  templateUrl: "./mosaico-item-super-trunfo.component.html",
  styleUrls: ["./mosaico-item-super-trunfo.component.scss"],
})
export class MosaicoItemSuperTrunfoComponent implements OnInit {
  @Input() link: any;
  @Input() title: any;
  @Input() tags: any;
  @Input() description: any;
  @Input() instructorname: any;
  @Input() instructorpicture: any;
  @Input() cover: any;
  @Input() comingsoon: any;
  @Input() datepublished: any;
  @Input() owned: any;
  @Input() proonly: any;
  @Input() progress: boolean;
  @Input() hiddenprice: boolean;

  isNew = false;
  videoprogress = 34;

  ngOnInit(): void {
    this.isNew = this.checkPostIsNew(this.datepublished, 60);
  }

  checkPostIsNew(datePublished: string, maxDays: number) {
    return checkPostIsNew(datePublished, maxDays);
  }
}
